var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1203_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6911 1.29637C23.0638 1.6718 23.3323 2.13903 23.47 2.65153C24.2626 5.86585 24.0795 10.9425 23.4853 14.2809C23.3477 14.7935 23.0791 15.2607 22.7064 15.6361C22.3338 16.0116 21.87 16.2821 21.3612 16.4208C19.4989 16.9325 12.0031 16.9325 12.0031 16.9325C12.0031 16.9325 4.50724 16.9325 2.6448 16.4208C2.13608 16.2821 1.6723 16.0115 1.29964 15.6361C0.926986 15.2607 0.658459 14.7934 0.520799 14.2809C-0.276544 11.0806 -0.0580132 6.00081 0.50533 2.66711C0.642976 2.1546 0.911497 1.68735 1.28415 1.3119C1.65681 0.93645 2.1206 0.665899 2.62933 0.527189C4.49177 0.0154888 11.9878 0 11.9878 0C11.9878 0 19.4835 0 21.346 0.5117C21.8547 0.650402 22.3185 0.920939 22.6911 1.29637ZM15.8202 8.4662L9.60199 12.0946V4.83783L15.8202 8.4662Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1203_6173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBl);
export default __webpack_public_path__ + "static/media/youtubeBl.8da8c1b66586e26c5db983b0b7ddc93d.svg";
export { ForwardRef as ReactComponent };